<template>
  <div class="apply">
    <ul
      class="fast-menu row align-center justify-around hide-m hide-g"
      :class="[roll ? `active` : ``, showFastMenu ? '' : 'roll']"
    >
      <li @click="active = true" :class="active ? 'active' : ''">
        Minhas candidaturas
      </li>
      <li @click="active = false" :class="!active ? 'active' : ''">
        Disponíveis para candidatura
      </li>
    </ul>

    <div class="title">
      Minhas
      <b>Candidaturas</b>
    </div>

    <div class="row column-s">
      <div
        class="grid-6 grid-12-s"
        :class="!active ? 'content-hide' : ''"
        style="border-right: 1px solid #ccc"
      >
        <div class="row sub">
          <div
            class="grid-3 grid-6-m grid-12-s subtab column row-g align-center"
            :class="tab ? 'active' : ''"
            @click="tab = true"
          >
            <div class="ball">{{ jobs.filter((j) => j.ativa).length }}</div>
            &nbsp; Candidaturas ativas &nbsp;
            <i class="fa fa-question-circle font-13 tip">
              <div>
                Jobs que você se candidatou e ainda tem chances de ser
                escolhido.
              </div>
            </i>
          </div>
          <div
            class="grid-3 grid-6-m grid-12-s subtab column row-g align-center"
            :class="!tab ? 'active' : ''"
            @click="tab = false"
          >
            <div class="ball red">
              {{ jobs.filter((j) => !j.ativa).length }}
            </div>
            &nbsp; Candidaturas inativas &nbsp;
            <i class="fa fa-question-circle font-13 tip">
              <div>
                Jobs que você se candidatou e não estão mais disponíveis.
              </div>
            </i>
          </div>
        </div>
        <div v-if="!jobs.length" class="text-center grid-12 noJob">
          <img src="../assets/img/error.svg" alt="erro" />
          <br />Nenhuma candidatura ativa.
        </div>
        <div v-if="tab" class="box row wrap">
          <Card
            v-for="(job, index) in jobs.filter((j) => j.ativa)"
            :key="'card' + index"
            :job="job"
          />
        </div>
        <div class="box row wrap" v-else>
          <Card
            v-for="(job, index) in jobs.filter((j) => !j.ativa)"
            :key="'card' + index"
            :job="job"
          />
        </div>
      </div>

      <div class="grid-6 grid-12-s box-2" :class="active ? 'content-hide' : ''">
        <div class="row sub align-center">
          <div class="ball ball-2">{{ available.length }}</div>
          &nbsp; Disponíveis para candidatura &nbsp;
          <i class="fa fa-question-circle font-13 tip">
            <div>Jobs disponíveis para candidatura.</div>
          </i>
        </div>

        <div class="box row wrap">
          <Card
            v-for="(ava, i) in available"
            :key="'av' + i"
            :job="ava"
            :apply="true"
          />

          <div v-if="!available.length" class="text-center grid-12 noJob">
            <img src="../assets/img/error.svg" alt="erro" />
            <br />Nenhum job encontrado nas cidades de preferência.
          </div>
        </div>
      </div>
    </div>
    <Telegram />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.apply {
  padding-bottom: 35px;

  .title {
    border-radius: 5px;
    font-size: 26px;
    margin-bottom: 40px;
    padding: 28px 5px;

    @media (max-width: $small) {
      margin-top: 38px;
      font-size: 1.3rem;
      text-align: center;
    }

    b {
      color: $supporter-1;
    }
  }
  .content-hide {
    @media (max-width: $small) {
      display: none;
    }
  }
  .tab {
    font-size: 14px;
    margin-top: -35px;
    background: $white;
    border-radius: 5px;
    margin-bottom: 50px;
    div {
      padding: 20px 0px;
    }

    .active {
      background: $green-2;
      color: $white;
    }
  }
  .box {
    height: 65vh;
    overflow: auto;

    &-2 {
      @media (min-width: $small) {
        margin-left: 50px;
      }
    }
  }

  .ball {
    float: left;
    border-radius: 50%;
    font-size: 11px;
    width: 30px;
    height: 27px;
    line-height: 27px;
    font-weight: bold;
    text-align: center;
    margin-top: 2px;
    margin-left: 10px;
    color: $white;
    background: $green-1;
    &-2 {
      background: $green-2;
    }
    &.red {
      background: $red;
    }
  }
  .sub {
    padding-bottom: 25px;
    color: $gray-4;
    font-size: 17px;

    .subtab {
      padding: 20px 0px;
      border-radius: 4px;
      margin-right: 6px;
      &:hover {
        background: $white-5;
        cursor: pointer;
      }
      &.active {
        /*   border: 1px solid #ccc; */
        border-bottom: none;
        background: $white-2;
      }
    }
  }
  .noJob {
    margin-top: 25%;
    img {
      width: 50px;
      margin-bottom: 10px;
    }
  }
}

.fast-menu {
  background: $black-3;
  color: $white;
  list-style: none;
  font-size: 14px;
  @media (max-width: $small) {
    font-size: 0.7rem;
  }
  position: absolute;
  width: 100%;
  left: 0px;
  height: 48px;
  top: 82px;
  z-index: 900;
  &.active {
    top: 0px;
    position: fixed;
  }

  &.roll {
    opacity: 0.3;
  }
  li {
    padding: 12px 0px;
  }
  .active {
    border-bottom: 5px solid $green-2;
  }
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import Card from "@/components/CardApply.vue";
import Telegram from "@/components/Telegram.vue";
export default {
  components: { Card, Telegram },
  data() {
    return {
      active: true,
      tab: true,
      roll: false,
      showFastMenu: true,
    };
  },
  methods: {
    ...mapActions("jobs", ["LOAD_APPLY", "LOAD_AVAILABLE"]),
  },
  beforeMount() {
    this.LOAD_APPLY();
    this.LOAD_AVAILABLE();
  },
  computed: {
    ...mapGetters("jobs", ["jobs", "available"]),
  },
};
</script>